const header = document.querySelector('#header');
const menuButton = document.getElementById('js-menu-button');
const closeButton = document.querySelectorAll('.js-close-menu-button');
const globalMenu = document.getElementById('js-nav');
const BREAKPOINT = 1200;

// MENU関連
const toggleMenu = (isOpen) => {
  const ariaExpandedValue = isOpen ? 'true' : 'false';
  const ariaLabelValue = isOpen ? 'メニューを閉じる' : 'メニューを開く';
  const ariaHiddenValue = isOpen ? 'false' : 'true';

  menuButton.setAttribute('aria-expanded', ariaExpandedValue);
  menuButton.setAttribute('aria-label', ariaLabelValue);
  globalMenu.setAttribute('aria-hidden', ariaHiddenValue);
};

const hideMenuFromPc = () => {
  const mql = window.matchMedia(`(min-width:${BREAKPOINT}px`);

  const mediaQueryHandler = (e) => {
    if (e.matches) {
      toggleMenu(true);
    } else {
      toggleMenu(false);
    }
  };

  mediaQueryHandler(mql);

  mql.addEventListener('change', mediaQueryHandler);
};

const clickMenuButton = () => {
  const handleClick = e => {
    if (e.currentTarget.getAttribute('aria-expanded') === 'false') {
      toggleMenu(true);
    } else {
      toggleMenu(false);
    }
  };


  menuButton.addEventListener('click', handleClick);
};

const clickCloseButton = () => {
  const handleClick = () => {
    toggleMenu(false);
  };

  closeButton.forEach(button => {
    button.addEventListener('click', handleClick);
  });
};

const clickMenuLink = () => {
  const links = document.querySelectorAll('#js-nav a');

  const handleLinkClick = e => {
    const href = String(e.currentTarget.href);
    if (href.includes('#')) {
      toggleMenu(false);
    }
  };

  links.forEach(link => {
    link.addEventListener('click', handleLinkClick);
  });
};

const adjustHeader = () => {
  const hash = location.hash;
  if (!hash) return;

  const headerHeight = header.clientHeight;
  const target = document.querySelector(`${hash}`);
  const rect = target.getBoundingClientRect();
  const targetTop = rect.top + window.scrollY - headerHeight - 0;

  document.documentElement.scrollTop = targetTop;
};

export default () => {
  clickMenuButton();
  hideMenuFromPc();
  clickMenuLink();
  clickCloseButton();

  setTimeout(() => {
    adjustHeader();
  });
};
